import { Alert } from '@/global/components/Alert'
import ConfirmarExclusao from 'global/guides/Dialog/ConfirmarExclusao'
import { useOutletContext, useParams } from 'react-router-dom'
import { Certificado, certificados } from 'service/api'
import { toast } from 'sonner'

export default function ExcluirCertificado() {
    const { certificadoId } = useParams()
    const certificadosData = useOutletContext<Certificado[]>()
    const { mutateAsync, isLoading } = certificados.mutations.useDelete({
        invalidateQuery: true,
    })

    if (!certificadoId) return null

    const isPrincipal =
        certificadosData.find(c => c.id === +certificadoId)?.tipo ===
        'principal'

    const handleSubmit = () => {
        mutateAsync(+certificadoId, {
            onSuccess: async () => {
                toast.success('Certificado excluído com sucesso')
            },
            onError: err => {
                toast.error(err.message)
            },
        })
    }

    return (
        <ConfirmarExclusao
            width="2xl"
            permissao={['delete', 'Certificados']}
            loading={isLoading}
            onConfirm={handleSubmit}
            title="Deseja realmente excluir o certificado?"
        >
            {isPrincipal && (
                <Alert severity="warning">
                    Ao excluir o certificado principal, a empresa ficará sem
                    certificado da empresa.
                    <br />
                    Você pode substituir o certificado principal ao criar um
                    novo certificado enquanto o atual estiver expirado.
                </Alert>
            )}
        </ConfirmarExclusao>
    )
}
